
import React from 'react'

const Logo = () => {
  return (
    <div className="pt-6 lg:pt-0 flex justify-start">
      <a href="/" aria-label="Home">
        <img
          width={150}
          src="https://signature.rollersoftware.com/email-logo.svg"
          alt="ROLLER - All-in-on Venue Management software"
          title="Roller"
        />
      </a>
    </div>
  );
}

export default Logo